export function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.readAsDataURL(file); // read file as base64

    reader.onload = () => resolve(reader.result);      // success
    reader.onerror = (error) => reject(error);         // error
  });
}
